import { BaseUrl } from 'environment';

// Login
export const Mobilelogin = `${BaseUrl}/user/LoginMobile`;
export const Login = `${BaseUrl}/user/login`;
export const Logout = `${BaseUrl}/user/logout`;
export const insertSignup = `${BaseUrl}/user/create`;
export const sendMail = `${BaseUrl}/user/sendMailOTP`;
export const validateEmail = `${BaseUrl}/user/emailRegister`;
export const validateMobile = `${BaseUrl}/user/mobileRegister`;
export const sendMobileOtp = `${BaseUrl}/user/sendOTP`;
export const userNameCreate = `${BaseUrl}/user/updateUsername`;
export const googleSignup = `${BaseUrl}/user/auth/google`;
export const appleSignup = `${BaseUrl}/user/auth/apple`;
export const Resetpassemail = `${BaseUrl}/user/resetPasswordMail`;
export const Resetpassmbl = `${BaseUrl}/user/resetPasswordMobile`;
export const Changepass = `${BaseUrl}/user/changePassword`;
export const validateUser = `${BaseUrl}/user/validateUser`;
export const updateUsernameOTP = `${BaseUrl}/user/validateUserName`;
export const changeUserName = `${BaseUrl}/user/changeuserName`;
export const changeRole = `${BaseUrl}/user/changeUserRole`;
export const changeAutoFollowRequest = `${BaseUrl}/user/changeAutoFollowRequest`;
export const changeMailorPhone = `${BaseUrl}/user/changeMailorPhone`;
export const verifyResetPassMbl = `${BaseUrl}/user/validateResetPasswordMobileOTP`;
export const verifyResetPassEmail = `${BaseUrl}/user/validateResetPasswordEmailOTP`;

// Dropdown List
export const getCategory = `${BaseUrl}/masters/category`;
export const getjobType = `${BaseUrl}/masters/jobType`;
export const getworkType = `${BaseUrl}/masters/workType`;
export const getCountry = `${BaseUrl}/masters/country`;
export const getCountrLocation = `${BaseUrl}/masters/countyInfo`;
export const getbusinessCategory = `${BaseUrl}/masters/businesspageCategory`;
export const getPostCategory = `${BaseUrl}/masters/postCategory`;
export const getReportReasons = `${BaseUrl}/masters/reportReasons`;

// Activity Post
export const ActivityPost = `${BaseUrl}/post`;
export const DeletePostById = `${BaseUrl}/post/byPostId`;
export const CommonPost = `${BaseUrl}/post/commonPosts/`;
export const NonFollowerPost = `${BaseUrl}/post/nonFollowers/`;
export const getPostRelations = `${BaseUrl}/post/relations`;
export const SavePost = `${BaseUrl}/post/savePost`;

// Postjob
export const insertJobPost = `${BaseUrl}/jobPost`;
export const getOtherLocation = `${BaseUrl}/getOtherLocation`;
export const getjobpostId = `${BaseUrl}/jobPost/`;
export const jobApply = `${BaseUrl}/jobSubmit`;
export const jobStatus = `${BaseUrl}/jobSubmit/status`;
export const jobAlert = `${BaseUrl}/jobAlert`;
export const manageMessage = `${BaseUrl}/manageMessage`;

// Network
export const follow = `${BaseUrl}/network`;
export const Suggestion = `${BaseUrl}/network/findFollowSuggestion`;
export const followerRequest = `${BaseUrl}/network/followerRequest`;
export const followRequest = `${BaseUrl}/network/followRequestedList`;
export const followerRequestAccept = `${BaseUrl}/network/acceptFollowerRequest`;
export const followerlist = `${BaseUrl}/network/followers`;
export const followinglist = `${BaseUrl}/network/following`;
export const mutedfollowers = `${BaseUrl}/network/mutedFollowers`;
export const blockedfollowers = `${BaseUrl}/network/blockedFollowers`;
export const withdrawRequest = `${BaseUrl}/network/withdrawFollower`;
export const removeorUnfollow = `${BaseUrl}/network/removeorUnfollow`;
export const blockFollowers = `${BaseUrl}/network/blockFollower`;
export const muteFollowers = `${BaseUrl}/network/muteFollower`;

// Profile Details
export const Skills = `${BaseUrl}/skills`;
export const Education = `${BaseUrl}/education`;
export const AddMore = `${BaseUrl}/additionalSection`;
export const Experience = `${BaseUrl}/experience`;
export const Profile = `${BaseUrl}/user`;
export const CurrentProfile = `${BaseUrl}/user/byname`;
export const CreateProfile = `${BaseUrl}/user/createProfile`;
export const Award = `${BaseUrl}/award`;
export const Attachment = `${BaseUrl}/attachment`;
export const Likes = `${BaseUrl}/likes`;
export const Comment = `${BaseUrl}/comments`;
export const CommentLikes = `${BaseUrl}/commentLikes`;
export const CommentReply = `${BaseUrl}/reply`;
export const ReplyLikes = `${BaseUrl}/replyLikes`;
export const Unlike = `${BaseUrl}/unlike`;
export const Reaction = `${BaseUrl}/commentReactions`;
export const ReplyReaction = `${BaseUrl}/replyReactions`;
export const Company = `${BaseUrl}/company`;
export const OrderSkill = `${BaseUrl}/skills/reorderSkills`;
export const Business = `${BaseUrl}/businessPage`;
export const businessList = `${BaseUrl}/businessPage/findAll`;
export const businessListByUsername = `${BaseUrl}/businessPage/byUsername`;
export const businessLikes = `${BaseUrl}/businessPageUpdates/likes`;
export const businessUnlikes = `${BaseUrl}/businessPageUpdates/unLikes`;
export const businessPageImage = `${BaseUrl}/businessPage/images`;
export const imagesDelete = `${BaseUrl}/businessPage/images`;
export const BusinessUpdateDelete = `${BaseUrl}/businessPage/updates`;
export const businessUpdatelist = `${BaseUrl}/businessPage/updates/businessPageId`;
export const mentionList  = `${BaseUrl}/user/name/list`;
export const hashtag  = `${BaseUrl}/masters/hashtags`;

// Resume
export const resumes = `${BaseUrl}/resumes`;
export const resumesFindAll = `${BaseUrl}/resumes/findAll`;
export const resumesHighlight = `${BaseUrl}/resumes/highlight`;

// Search
export const commonsearch = `${BaseUrl}/commonsearch`;

// Notification
export const notification = `${BaseUrl}/notifications`;
export const notificationStatus = `${BaseUrl}/notifications/status`;
export const notificationLastSeen = `${BaseUrl}/userActivity`;
export const saveDeviceToken = `${BaseUrl}/user/savedeviceToken`;

// Before Login
export const landingFeed = `${BaseUrl}/post/landing`;
export const landingBusiness = `${BaseUrl}/businessPage/landing/pages`;

// Settings
export const manageMention = `${BaseUrl}/user/manageMention`;
